const getPropertyLink = ({ propertyContent, searchQuery, packageOffer }) => {
  const propertyContentDestination = propertyContent.destination
    ? propertyContent.destination.name
    : null;
  if (!propertyContentDestination) {
    return null;
  }
  const pathname = `/${propertyContentDestination}/properties/${propertyContent.id}/package`;

  return {
    pathname,
    query: {
      ...searchQuery,
      ...(packageOffer && {
        leadInRoomTypeId: packageOffer.roomTypeId,
      }),
      ...(propertyContent.theme && {
        themeName: propertyContent.theme.name,
      }),
    },
  };
};

export default getPropertyLink;
